import PropTypes from "prop-types";
import styles from "./ContactListItem.module.css";
import classNames from "classnames";
import { CONTACT_TYPE } from "shared/enums";
import { ContactStatusBadge } from "../ContactStatusBadge/ContactStatusBadge";
import { Link } from "react-router-dom";

function hasBitwise(status, value) {
  return (value & status) == status;
}

/**
 * A contact list item representing one contact.
 */
export function ContactListItem({ contact, getContactPath, isSelected }) {
  const { name, type: contactType, isIBO, progression } = contact;

  const content = (
    <>
      <span className={styles.name}>{name}</span>
      <div className={styles.status}>
        {hasBitwise(CONTACT_TYPE.Customer, contactType) && (
          <ContactStatusBadge type={CONTACT_TYPE.Customer} />
        )}
        {hasBitwise(CONTACT_TYPE.Prospect, contactType) && (
          <ContactStatusBadge
            type={CONTACT_TYPE.Prospect}
            progression={progression}
          />
        )}
        {hasBitwise(CONTACT_TYPE.Archived, contactType) && (
          <ContactStatusBadge type={CONTACT_TYPE.Archived} />
        )}
        {isIBO ? <ContactStatusBadge type={undefined} /> : null}
      </div>
    </>
  );

  if (getContactPath) {
    return (
      <Link
        to={getContactPath(contact)}
        className={classNames({
          [styles.item]: true,
          [styles.archived]: hasBitwise(CONTACT_TYPE.Archived, contactType),
          [styles.ibo]: isIBO,
          [styles.selected]: isSelected,
        })}
      >
        {content}
      </Link>
    );
  } else {
    return (
      <div
        className={classNames({
          [styles.item]: true,
          [styles.archived]: hasBitwise(CONTACT_TYPE.Archived, contactType),
          [styles.ibo]: isIBO,
          [styles.selected]: isSelected,
        })}
      >
        {content}
      </div>
    );
  }
}

ContactListItem.propTypes = {
  /**
   * Contact record.
   */
  contact: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.number,
    isIBO: PropTypes.bool.isRequired,
  }).isRequired,

  /**
   * If true the item is highlighted on the desktop layout.
   */
  isSelected: PropTypes.bool,

  /**
   * Function that receives a contact record and returns a URL path pointing to it.
   */
  getContactPath: PropTypes.func,
};
